// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsList_container__27oL-","pagination":"NotificationsList_pagination__22ApF","paginationNumbers":"NotificationsList_paginationNumbers__1IINR"};